export const LossAndDamageClaimsTypes = {
  SET_CLAIM_EDIT_DRAWER: 'LOSS_AND_DAMAGE.SET_CLAIM_EDIT_DRAWER',
  SET_CLAIM_SEARCH_VIEW_TYPE: 'LOSS_AND_DAMAGE.SET_CLAIM_SEARCH_VIEW_TYPE',
  SET_CLAIM_SEARCH_VIEW_TYPE_INITIAL: 'LOSS_AND_DAMAGE.SET_CLAIM_SEARCH_VIEW_TYPE_INITIAL',
  SET_CLAIMS_FILTERS: 'LOSS_AND_DAMAGE.SET_CLAIMS_FILTERS',
  SET_FILTER_TYPE: 'LOSS_AND_DAMAGE.SET_FILTER_TYPE',
  SET_SELECTED_CLAIM_KEY: 'LOSS_AND_DAMAGE.SET_SELECTED_CLAIM_KEY',
  SET_SELECTED_CLAIMS: 'LOSS_AND_DAMAGE.SET_SELECTED_CLAIMS',
} as const;
